import { NgModule, ErrorHandler } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';

// Pruebas para Firestore
import { AngularFirestoreModule, AngularFirestore } from '@angular/fire/firestore';

import { AngularFireStorageModule, StorageBucket } from '@angular/fire/storage';
import { AngularFireDatabaseModule } from '@angular/fire/database';
// import { AngularFireMessagingModule } from '@angular/fire/messaging';

/*Services*/
import { AuthService } from '@services/auth.service';
import { CallService } from '@services/call.service';
import { DataProvider } from '@services/data/base.data-provider';
// import { LocalDataProvider } from '@services/data/local.data-provider';
import { FirebaseDataProvider } from '@services/data/firebase.data-provider';
import { RemoteDataProvider } from '@services/data/remote.data-provider';

// import { BackendlessDataProvider } from '@services/data/backendless.data-provider';
import { EmailService } from '@services/email.service';
import { InAppBrowserService } from '@services/in-app-browser.service';
import { OpenHoursService } from '@services/open-hours.service';
import { FavoritesService } from '@services/favorites.service';

import locale from '@angular/common/locales/es';
import { Config } from '../config';
import { NgxWebstorageModule } from 'ngx-webstorage';
registerLocaleData(locale, 'es');
import { ComponentsModule } from './pages/components/components.module';
import { OneSignalModule } from './pages/push/one-signal.module';
import { AuthGuard } from './services/auth-guard.service';
import { AuthResolver } from './services/auth.resover';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    HttpClientModule,
    BrowserModule,
    ComponentsModule,
    IonicModule.forRoot(),
    BrowserAnimationsModule,
    AppRoutingModule,

    NgxWebstorageModule.forRoot(),
    AngularFireModule.initializeApp(Config.firebase),
    // Pruebas firestore
    AngularFirestoreModule,
    //    AngularFireMessagingModule,
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    AngularFireStorageModule,
    ServiceWorkerModule.register('combined-sw.js', { enabled: environment.production })
  ],
  providers: [
    Config,
    AuthGuard,
    // { provide: ErrorHandler, useClass: IonicErrorHandler },
    // { provide: DataProvider, useClass: LocalDataProvider },
    { provide: DataProvider, useClass: AngularFirestore },
    { provide: DataProvider, useClass: FirebaseDataProvider },
    // { provide: DataProvider, useClass: RemoteDataProvider },
    // { provide: DataProvider, useClass: BackendlessDataProvider },
    EmailService,
    CallService,
    InAppBrowserService,
    OpenHoursService,
    FavoritesService,
    AuthService,
    OneSignalModule,

    AuthResolver,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
    // { provide: StorageBucket, useValue: 'gs://lasbarandas-dedoclic-38ff4.appspot.com/' },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
